import install1 from '../images/install1.png';
import install2 from '../images/install2.png';
import install3 from '../images/install3.png';
import lock1 from '../images/lock-1.png';
import lock2 from '../images/lock-2.png';
import lock3 from '../images/lock-3.png';
import tap1 from '../images/tap1.png';
import tap2 from '../images/tap2.png';
import fan1 from '../images/ceiling-fan-1.png';
import fan2 from '../images/switch.png';
import fan3 from '../images/ceiling-fan-2.png';
import bathroom1 from '../images/bathroom-heat-1.png';
import bathroom2 from '../images/bathroom-heat-2.png';
import bathroom3 from '../images/bathroom-heat-3.png';
import Hero from '../images/form-hero.jpg';
import HeroMobile from '../images/form-hero-mobile.jpg';
import tapHero from '../images/tap-hero.png';
import ceilingFanHero from '../images/ceiling-fan-background.png';
import heatLampHero from '../images/bathroom-heat-background.png';
import lockHero from '../images/lock-hero.png';
import newFan1 from '../images/wiring-roof.png';
import newFan2 from '../images/roof-access.png';
import newFan3 from '../images/wall-access.png';

const toiletData = {
  sections: [
    {
      text: 'Ensure your water and waste connections are in place',
      image: install1
    },
    {
      text: 'Check your toilet matches your waste connection (S Trap or P Trap)',
      image: install2
    },
    {
      text: ' Ensure your new toilet is either a close coupled or back-to-wall unit',
      image: install3
    }
  ],
  service: 'Toilet Installation',
  name: 'toilet replacement installation',
  pureName: 'toilet',
  faq: 'toilet-installation',
  installationTime: 'up to three hours',
  setting: {
    lg: Hero,
    md: Hero,
    sm: HeroMobile,
    xs: HeroMobile
  }
};

const lockData = {
  sections: [
    {
      text: 'Ensure your purchased lock is compatible with the thickness of your door',
      image: lock1
    },
    {
      text: 'Ensure the lock to be installed is not a mortice lock',
      image: lock2
    },
    {
      text:
        'If your property is a unit or apartment, ensure the purchased lock is permitted to be fitted',
      image: lock3
    }
  ],
  service: 'Door Lock Installation',
  name: 'door lock installation',
  pureName: 'door lock',
  faq: 'door-lock-installation',
  installationTime: 'up to one hour',
  setting: {
    lg: lockHero,
    md: lockHero,
    sm: lockHero,
    xs: lockHero
  }
};

const tapData = {
  sections: [
    {
      text: 'Ensure the new tap will fit the hole(s) left by the old taps',
      image: tap1
    },
    {
      text: 'Make sure the connections for the tap are easily accessible',
      image: tap2
    }
  ],
  service: 'Tap',
  name: 'tap replacement installation',
  pureName: 'tap',
  faq: 'sink-mixer-installation',
  installationTime: '30 mins to 45 mins',
  setting: {
    lg: tapHero,
    md: tapHero,
    sm: tapHero,
    xs: tapHero
  }
};

const ceilingFanData = {
  sections: [
    {
      text:
        'You have an existing fan and are not replacing a light fitting nor conducting a new install',
      image: fan1
    },
    {
      text: 'If your new fan has a wall control, your existing fan must also have a wall control',
      image: fan2
    },
    {
      text: 'Your new fan has a blade width of 1.4 metres or less',
      image: fan3
    }
  ],
  service: 'Ceiling Fan',
  name: 'ceiling fan installation',
  pureName: 'ceiling fan',
  faq: 'ceiling-fan-installation',
  installationTime: '45 minutes to 1 hour',
  setting: {
    lg: ceilingFanHero,
    md: ceilingFanHero,
    sm: ceilingFanHero,
    xs: ceilingFanHero
  }
};

const newCeilingFanData = {
  sections: [
    {
      text:
        'There is an existing power supply to the room or location where the fan is to be installed',
      image: newFan1
    },
    {
      text: 'There is access to run cables in the ceiling void',
      image: newFan2
    },
    {
      text: 'The wall where the switch is to be mounted is NOT a solid brick or block work wall.',
      image: newFan3
    }
  ],
  service: 'New Ceiling Fan',
  name: 'new ceiling fan installation',
  pureName: 'new ceiling fan',
  faq: 'ceiling-fan-installation',
  installationTime: 'up to two hours',
  setting: {
    lg: ceilingFanHero,
    md: ceilingFanHero,
    sm: ceilingFanHero,
    xs: ceilingFanHero
  }
};

const bathroomHeatData = {
  sections: [
    {
      text:
        "Ensure you're replacing an existing heat light or exhaust fan, not conducting a new install or replacing a regular light fitting",
      image: bathroom1
    },
    {
      text:
        'If your bathroom heat light or exhaust fan requires ducting, that ducting is already present. (Units with inline fans are excluded from this offer)',
      image: bathroom2
    },
    {
      text:
        'The hole required in the ceiling for your new unit must be the same size or bigger than the current hole. ',
      image: bathroom3
    }
  ],
  service: 'Heat Light Or Exhaust Fan',
  name: 'bathroom heat light or exhaust fan replacement installation',
  pureName: 'bathroom heat light or exhaust fan',
  faq: 'bathroom-heat-lamp-installation',
  installationTime: '45 minutes to 1 hour',
  setting: {
    lg: heatLampHero,
    md: heatLampHero,
    sm: heatLampHero,
    xs: heatLampHero
  }
};

export default {
  0: '',
  1456: toiletData,
  1458: tapData,
  1461: ceilingFanData,
  1462: bathroomHeatData,
  1464: lockData,
  1482: newCeilingFanData
};
